var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4293 5.9842C30.4293 2.87241 27.8089 0.251953 24.6971 0.251953C21.5853 0.251953 18.9648 2.87241 18.9648 5.9842V18.2676H6.68146C3.56967 18.2676 0.949219 20.888 0.949219 23.9998C0.949219 27.1116 3.56967 29.7321 6.68146 29.7321H14.0515L30.4293 8.93221V5.9842Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.714 18.269H30.4306V8.93359L14.0527 29.7335H19.1298V42.0168C19.1298 45.1286 21.7503 47.7491 24.8621 47.7491C27.9739 47.7491 30.5943 45.1286 30.5943 42.0168V29.7335H42.8777C45.9895 29.7335 48.61 27.113 48.61 24.0012C48.4462 20.8894 45.8257 18.269 42.714 18.269Z",
    fill: "#00C853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagePlus);
export default __webpack_public_path__ + "static/media/bage_plus.02a59d889f2dfe2ad1f3ed553e5a17ed.svg";
export { ForwardRef as ReactComponent };